/**
 * Module Name Formatter.
 * Shows the title when one is set, otherwise the module name.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.moduleNameFormatter = function(value, row) {
    let hasTitle = row.title !== null && row.title !== undefined && String(row.title).trim() !== '';
    let display = hasTitle ? row.title : value;

    return String(display === null || display === undefined ? '' : display)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
};
